import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { AccessControlService } from "../services/access-control.service";
import { SharedService } from "../shared-service/shared.service";
import { RoleTypeEnum } from "../enum/roles.enum";
@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private accessControlService: AccessControlService,
    private sharedService: SharedService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const userType =
      localStorage.getItem("type") == "0"
        ? RoleTypeEnum.ORGANIZATION_ROLE
        : RoleTypeEnum.CLIENT_ROLE;
    const expectedUserType = next.data.expectedRole;
    if (localStorage.getItem("token")) {
      if (expectedUserType) {
        if (expectedUserType.some((x) => x == userType)) return true;
        else {
          // this.sharedService.tokenExpiredEvent.next('changed');
          this.router.navigate(["page-not-found"]);
          return false;
        }
      } else return true;
    } else {
      this.sharedService.tokenExpiredEvent.next("changed");
      this.router.navigate(["login"]);
      return false;
    }
  }
}
